<!-- Pending requests section -->
@if (hasRequests()) {
  <div class="flex w-full flex-col gap-6 rounded-3xl border border-text-extra-light bg-background-white p-4">
    <div class="flex flex-col gap-1">
      <h3 class="typo-h3-semibold text-text-primary">{{ 'baa_request_list_section_title' | translate }}</h3>
      <p class="typo-h4-light font-extralight text-text-secondary">{{ 'baa_request_list_section_subtitle' | translate }}</p>
    </div>

    <div>
      @for (request of requests(); track request.id; let last = $last) {
        <div class="flex flex-col items-center gap-4 rounded-2xl">
          <div class="flex w-full items-start gap-3">
            <!-- Avatar -->
            <lib-avatar-initials [email]="request.requesterEmail" [size]="40" />

            <!-- Info -->
            <div class="flex flex-col gap-1">
              <p class="typo-h4-semibold truncate text-text-primary">{{ request.requesterName }}</p>
              <p class="typo-h5-light truncate font-extralight text-text-tertiary">{{ request.requesterEmail }}</p>
            </div>
          </div>

          <!-- Actions -->
          @if (request.status === 'pending') {
            <div class="flex w-full items-center justify-center gap-2">
              <button
                type="button"
                class="btn-secondary w-full items-center justify-center"
                [disabled]="isActionLoading()"
                (click)="deny.emit(request.id)"
              >
                {{ 'baa_request_list_deny_cta' | translate }}
              </button>
              <button
                type="button"
                class="btn-primary w-full items-center justify-center"
                [disabled]="isActionLoading()"
                (click)="approve.emit(request.id)"
              >
                {{ 'baa_request_list_approve_cta' | translate }}
              </button>
            </div>
          } @else {
            <div class="flex w-full flex-col gap-2">
              <span
                class="typo-h4-semibold flex w-full items-center justify-center gap-1 rounded-2xl bg-background-disabled py-2 text-text-light"
              >
                @if (request.status === 'approved') {
                  <svg-icon key="px-16-check" size="sm"></svg-icon>
                  {{ 'baa_request_list_status_approved' | translate }}
                } @else {
                  <svg-icon key="px-16-x" size="sm"></svg-icon>
                  {{ 'baa_request_list_status_denied' | translate }}
                }
              </span>
              <p class="typo-h5-light w-full text-center font-extralight text-text-secondary">
                @if (request.status === 'approved') {
                  {{ 'baa_request_list_all_set_notified_description' | translate: { input1: request.requesterName } }}
                } @else {
                  {{ 'baa_request_list_status_denied_notified' | translate }}
                }
              </p>
            </div>
          }
        </div>
        @if (!last) {
          <hr class="my-6 h-[1px] w-full border-background-disabled" />
        }
      }
    </div>
  </div>
}
